import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  ShoppingCart,
  TrendingUp,
  Truck,
  AlertTriangle,
  DollarSign,
  User,
  CheckCircle2,
  Activity,
  FileText,
  Crown,
  Building2,
  Search,
} from "lucide-react";
import { getActivityFeed } from "../lib/api";

const ICONS = {
  ShoppingCart,
  TrendingUp,
  Truck,
  AlertTriangle,
  DollarSign,
  User,
  CheckCircle2,
  Activity,
  FileText,
  Crown,
  Building2,
  Search,
};

/** Slow, elegant single-line activity ticker. One event every ~10 seconds. */
export default function ActivityTicker() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await getActivityFeed();
        if (!cancelled) setItems(data.items || []);
      } catch {}
    };
    load();
    const refresh = setInterval(load, 30000);
    return () => {
      cancelled = true;
      clearInterval(refresh);
    };
  }, []);

  useEffect(() => {
    if (items.length === 0) return;
    const tick = setInterval(() => {
      setIdx((i) => (i + 1) % items.length);
    }, 10000); // one item every 10s
    return () => clearInterval(tick);
  }, [items]);

  if (items.length === 0) return null;
  const cur = items[idx];
  const Icon = ICONS[cur.icon] || Activity;

  return (
    <div className="border-t border-border bg-[#0A0A0E]/90 backdrop-blur-md shrink-0" data-testid="activity-ticker">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <AnimatePresence mode="wait">
          <motion.div
            key={cur.id}
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -4 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="flex items-center gap-3 text-xs"
          >
            <span className="relative flex w-1.5 h-1.5 shrink-0">
              <span className="absolute inline-flex h-full w-full rounded-full bg-primary opacity-50 animate-ping" />
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-primary" />
            </span>
            <Icon className={`w-3.5 h-3.5 ${cur.color}`} />
            <span className="text-zinc-300 truncate">{cur.text}</span>
            <span className="text-zinc-600 text-[10px] tracking-wide font-mono mr-auto shrink-0">
              לפני {cur.seconds_ago} שניות
            </span>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
